import React from 'react';
import PropTypes from 'prop-types';

const DefinitionTerm = (
  {
    children: receivedChildren,
    classNames = [],
    preprocessDefinitionTerms,
    preprocessNestingTerms,
    hasNestedDefinitionList
  }
) => {
  let children = receivedChildren;
  const itemAttributes = {};

  if (preprocessDefinitionTerms && !(preprocessNestingTerms && hasNestedDefinitionList)) {
    children = preprocessDefinitionTerms(children);
  }

  if (hasNestedDefinitionList) {
    classNames.push('has-nested-data-list');

    if (preprocessNestingTerms) {
      children = preprocessNestingTerms(children);
    }
  }

  if (classNames.length > 0) {
    itemAttributes.className = classNames.join(' ');
  }


  return (
    <dt {...itemAttributes}>
      <div className='overflow-limiter'>
        {children}
      </div>
    </dt>
  );
};


DefinitionTerm.propTypes = {
  classNames: PropTypes.arrayOf(PropTypes.string),
  preprocessDefinitionTerms: PropTypes.func,
  preprocessNestingTerms: PropTypes.func,
  hasNestedDefinitionList: PropTypes.bool
};

export default DefinitionTerm;